<common-activity-type-base [activity]="activity">
  <!-- not done with this component.  -->
  <div>
    <div class="mt-3">
      <h4 class="mr-4 d-flex justify-content-center">Is this machine available?</h4>
      <div class="form-group d-flex justify-content-center">
        <div class="form-check form-check-inline radio-button">
          <common-radio-button id="machineAvailableYes" groupName="machineAvailable" label="Yes" [value]="true" [(model)]="available"> </common-radio-button>
        </div>
        <div class="form-check form-check-inline radio-button">
          <common-radio-button id="machineAvailableNo" groupName="machineAvailable" label="No" [value]="false" [(model)]="available"> </common-radio-button>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <!-- <button type="button" class="btn btn-success btn-block btn-modal-footer" (click)="save()" [disabled]="disableButton">Submit</button> -->
    </div>
  </div>
</common-activity-type-base>
